module.exports = __webpack_public_path__ + "img/calendar (1).1ec09f84.png";